<script setup>
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

const props = defineProps({
  conversationId: { type: [Number, String], required: true },
});

const { t } = useI18n();
const store = useStore();

const onAbort = () => {
  store.dispatch('aiAssistAbort', { conversationId: props.conversationId });
};
</script>

<template>
  <div class="flex items-center justify-center px-4 py-2.5">
    <button
      type="button"
      class="inline-flex items-center gap-2 px-4 py-1.5 text-sm font-semibold text-white rounded-lg shadow-sm cursor-pointer bg-n-ruby-9 hover:bg-n-ruby-10"
      @click="onAbort"
    >
      <span
        class="inline-block border-2 rounded-full w-3.5 h-3.5 border-current border-t-transparent animate-spin"
      />
      {{ t('CUSTOM.AI_ASSIST.ABORT') }}
    </button>
  </div>
</template>
